import { useAscPageLockStatus } from '@neo.tax/asc/hooks';
import { RedirectState, useOnboardingFlowStage, useCompanyInformation, useProducts } from '@neo.tax/shared';

export const useAscProjectsRedirect = (): RedirectState => {
  const { loading: loadingCompanyInformation } = useCompanyInformation();
  const { loading: loadingOnboardingFlowStage } = useOnboardingFlowStage();
  const { loading: loadingPageLockStatus } = useAscPageLockStatus();
  const { loading: loadingProducts } = useProducts();

  return {
    isLoading: loadingCompanyInformation || loadingOnboardingFlowStage || loadingPageLockStatus || loadingProducts,
  };
};
